import { createAsyncThunk } from '@reduxjs/toolkit';
import { recentSowChangesStoreKey } from './recentSowChanges.const';
import axios, { AxiosResponse } from 'axios';
import { apiEndpoints } from '../../constants/api';
import {
  FetchRecentOperationalChangesPayload,
  RecentSOWChangesState,
} from './recentSowChanges.types';
import { notificationAlert } from '../notifications';
import { formatErrorMessage } from '../../utils';
import {
  ExecuteSowChangeReqRespDto,
  SowChangeReqFullDto,
} from '../../types/sow-change-req';

export const fetchRecentSowChanges = createAsyncThunk(
  `${recentSowChangesStoreKey}/fetch-recent-changes`,
  async (payload: FetchRecentOperationalChangesPayload) => {
    try {
      const response: AxiosResponse<RecentSOWChangesState> = await axios.post(
        apiEndpoints.recentSowChanges(),
        payload,
      );

      return response.data;
    } catch (err) {
      throw new Error(String(err));
    }
  },
);

export const executeSowChangeReq = createAsyncThunk(
  `${recentSowChangesStoreKey}/executeSowChangeReq`,
  async (payload: { id: string }, thunkAPI) => {
    try {
      const response: AxiosResponse<ExecuteSowChangeReqRespDto> =
        await axios.post(apiEndpoints.executeSowChangeReq(), payload);

      thunkAPI.dispatch(notificationAlert('Changes request approved'));

      return response.data;
    } catch (err) {
      thunkAPI.dispatch(
        notificationAlert(formatErrorMessage(err), { variant: 'error' }),
      );
      throw new Error(String(err));
    }
  },
);

export const rejectSowChangeReq = createAsyncThunk(
  `${recentSowChangesStoreKey}/rejectSowChangeReq`,
  async (payload: { id: string; declineNotes: string }, thunkAPI) => {
    try {
      const response: AxiosResponse<SowChangeReqFullDto> = await axios.post(
        apiEndpoints.rejectSowChangeReq(),
        payload,
      );

      thunkAPI.dispatch(notificationAlert('Change requested rejected'));
      return response.data;
    } catch (err) {
      thunkAPI.dispatch(
        notificationAlert(formatErrorMessage(err), { variant: 'error' }),
      );
      throw new Error(String(err));
    }
  },
);

export const downloadRecentSowChanges = createAsyncThunk(
  `${recentSowChangesStoreKey}/download-recent-changes`,
  async (payload: FetchRecentOperationalChangesPayload) => {
    try {
      const response: AxiosResponse<RecentSOWChangesState> = await axios.post(
        apiEndpoints.recentSowChanges(),
        payload,
      );

      return response.data;
    } catch (err) {
      throw new Error(String(err));
    }
  },
);
